import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { Button } from 'Button';
import { formattedUserFacingMonthDayYearLong } from 'DateHelpers';
import { useCurrentUser } from 'FrontRoyalAngular';
import { type LearnerProject, getProjectDates, usePeriodIndexForProjectUnlock } from 'LearnerProjects';
import { Text } from 'Text';
import { getCohort } from 'Users';
import './locales/project_group_creation_success_modal_page-en.json';

const Description = ({ project }: { project: LearnerProject }) => {
    const { t } = useTranslation('back_royal');
    const currentUser = useCurrentUser();
    const cohort = getCohort(currentUser);
    const projectPeriodIndex = usePeriodIndexForProjectUnlock(project.requirementIdentifier);
    const { endDate } = getProjectDates(cohort, project, projectPeriodIndex);

    return (
        <Text color="black">
            <Trans
                i18nKey="project_group_creation_success_modal_page.description"
                t={t}
                components={{
                    strong: <span className="font-bold" />,
                }}
                values={{
                    projectTitle: project.title,
                    projectSubmissionDeadline: formattedUserFacingMonthDayYearLong(endDate),
                }}
            />
        </Text>
    );
};

const FormSubmissionButtons = ({ onConfirm, className }: { onConfirm: () => void; className?: string }) => {
    const { t } = useTranslation('back_royal');
    return (
        <div className={twMerge('flex justify-center', className)}>
            <Button variant="solid" color="black" onPress={onConfirm}>
                {t('project_group_creation_success_modal_page.confirm_button_label')}
            </Button>
        </div>
    );
};

const ProjectGroupCreationSuccessPageComponent = ({
    project,
    onConfirm,
}: {
    project: LearnerProject;
    onConfirm: () => void;
}) => (
    <div className="flex h-full flex-col">
        <Description project={project} />
        <FormSubmissionButtons className="mt-12.5" onConfirm={onConfirm} />
    </div>
);

export const ProjectGroupCreationSuccessModalPage = memo(ProjectGroupCreationSuccessPageComponent);
